import type { SimpleFilter, AdvancedFilters } from './filters'

export const createAdvancedFilter = (...filters: SimpleFilter[]): AdvancedFilters => ({
  conjunction: 'and',
  filters,
})
